import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

import { useUserSelector } from 'hooks/useUser';
import { CompanyContextProvider } from 'hooks/useCompany';
import { ReferralContextProvider } from 'hooks/useReferral';

export function ProtectedRoute({ children, requiredProfileCompleted }) {
  const { isLoggedIn, isLoading, isUserProfileCompleted, isOnboardingPersonalDataCompleted } =
    useUserSelector();

  if (!isLoggedIn && !isLoading) {
    return <Navigate to="/login" replace />;
  }
  if (isLoading) {
    return <Spinner animation="grow" variant="info" size="lg" />;
  }
  if ((!isOnboardingPersonalDataCompleted || !isUserProfileCompleted) && requiredProfileCompleted) {
    return <Navigate to="/profile/intro" replace />;
  }

  return (
    <CompanyContextProvider>
      <ReferralContextProvider>
        <Helmet>
          <title>Partner Dashboard - Upscore</title>
          <description></description>
        </Helmet>

        {children}
      </ReferralContextProvider>
    </CompanyContextProvider>
  );
}
